import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AdminService } from '../../admin.service';
import { CategoryMapping } from '../../../shared/models/category-mapping';
import { Flow, FeatureStatusUpdate, draftCategory, Feature } from '../../../shared/models/Flow';
import { SelectionModel } from '@angular/cdk/collections';
import { TCCPLocalStorageService } from '../../../shared/services/tccp-local-storage.service';
import { environment } from '../../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PreviewFeatureFlowDialogComponent } from '../../../shared/components/preview-feature-flow-dialog/preview-feature-flow-dialog.component';
import { TCCPCommonService } from '../../../shared/services/tccp-common.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-draft-feature',
  templateUrl: './draft-feature.component.html',
  styleUrls: ['./draft-feature.component.scss']
})
export class DraftFeatureComponent implements OnInit {

  public displayedColumns: string[] = [];
  public resourceDataSource = new MatTableDataSource([]);
  public features: Flow[];
  public feature: FeatureStatusUpdate = <FeatureStatusUpdate>{};
  public hasPermission = false;
  public updaterequestArr = [];
  public flowDetails = [];
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  selection = new SelectionModel<Flow>(true, []);
  public success: string[] = [];
  public failure: string[] = [];

  constructor(
    private dialog: MatDialog, private commonService: TCCPCommonService, private storageService: TCCPLocalStorageService,
    private adminService: AdminService, private datePipe: DatePipe, public authService: MsalService, private router: Router) {
    this.displayedColumns = ['select', 'controls.controlName', 'featureType', 'lastModifiedBy', 'lastModifiedDate', 'category'];
  }

  ngOnInit() {
    this.getAllFeatures();
    const roles: string[] = this.storageService.getRoles();
    const userAccess = this.commonService.getAccess('Publish', roles);
    const accessLevel = _.get(userAccess[0], 'accessLevel');
    if (accessLevel === 1) {
      this.hasPermission = true;
    } else if (accessLevel === 3) {
      this.hasPermission = false;
    }
    this.adminService.refreshDraftFeatures.subscribe(data => {
      if (data) {
        this.getAllFeatures();
      }
    });
  }

  getAllFeatures() {
    this.adminService.getFlow(null, null, 'draft').subscribe(response => {
      console.log('getAllFeatures', response);
      let sortedContents = [];
      this.selection = new SelectionModel<Flow>(true, []);
      sortedContents = response.sort((val1, val2) => {
        return new Date(val2.lastModifiedDate).getTime() - new Date(val1.lastModifiedDate).getTime();
      });

      this.resourceDataSource.data = sortedContents;
      setTimeout(() => {

        this.resourceDataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'controls.controlName': return item.controls[0].featureName;
            case 'lastModifiedDate': {
              return new Date(item.lastModifiedDate).getTime();
            }
            default: return item[property];
          }
        };
        this.resourceDataSource.sort = this.sort;
        this.resourceDataSource.paginator = this.paginator;
      });

      this.resourceDataSource.filterPredicate = (data: any, filter) => {
        const dataStr = JSON.stringify(data).toLowerCase();
        return dataStr.indexOf(filter) !== -1;
      };

    });
  }

  applyFilter(filterValue: string) {
    this.resourceDataSource.filter = filterValue.trim().toLowerCase();
  }

  updateCategoryMappingOrder(categoryRequest) {
    this.updaterequestArr = [];
    categoryRequest.forEach(x => {
      const obj: CategoryMapping = <CategoryMapping>{};
      obj.category = x.category;
      obj.updatedBy = this.authService.instance.getActiveAccount().username;
      obj.division = this.adminService.selectedApplication;
      obj.issueId = x.issueId;
      obj.supportTopicName = x.controls[0].featureName;
      obj.featureType = x.featureType;
      this.updaterequestArr.push(obj);
    });

    this.adminService.getCategoryMappingOrder().subscribe(response => {
      if (response) {
        response.forEach(x => {
          this.updaterequestArr.forEach((y, index) => {
            y.order = response.length + index + 1;
            if (x.issueId === y.issueId) {
              y.isCategoryOrderExists = true;
              y.order = response.length + index + 1;
              y.category = x.category;

            }
          });
        });
        this.updaterequestArr.forEach((a, index) => {
          if (!a.isCategoryOrderExists) {
            this.updaterequestArr.splice(index, 1);
          }
        });
        console.log(' this.updaterequestArr', this.updaterequestArr);
        this.adminService.updateCategoryMappingOrder(this.updaterequestArr).subscribe(updateresponse => {
          if (updateresponse) {
            console.log('updateCategoryMappingOrder', updateresponse);
          }
        });
      }
    });
  }

  publishFeature() {
    this.adminService.closeFeatureExpansionPanel.emit(true);
    this.success = [];
    this.failure = [];
    const updateOrderRequestParam = this.selection.selected;
    this.feature.issueId = this.selection.selected.map(x => x.issueId);

    const a = {};
    this.selection.selected.forEach(x => {
      a[x.issueId] = x['publishedDate'] === undefined ? 'new' : '';
    });
    this.feature.firstPublishedDate = a;
    this.feature.source = this.adminService.selectedApplication;
    this.feature.status = 'published';
    this.feature.draftCategory = { draftCategory: '', draftMessage: '' } as draftCategory;
    this.adminService.updateStatus(this.feature).subscribe(data => {
      if (data) {
        console.log('feature move to draft', this.feature, updateOrderRequestParam);
        //  this.updateCategoryMappingOrder(updateOrderRequestParam);
        this.selection.selected.forEach(element => {
          if (data.indexOf(element.issueId) > -1) {
            this.success.push(element.controls[0].featureName);
          } else {
            this.failure.push(element.controls[0].featureName);
          }
        });
        this.selection = new SelectionModel<Flow>(true, []);
        this.getAllFeatures();
      }
    });
  }

  deleteSelectedFeatures() {
    this.success = [];
    this.failure = [];
    let features = [];
    this.selection.selected.forEach(x => {
      const feature: Feature = {
        issueId: x.issueId,
        featureType: x.featureType,
        source: this.adminService.selectedApplication
      };
      features.push(feature);
    });
    this.adminService.deleteFeaturesInBulk(features).subscribe(data => {
      if (data) {
        console.log('Deleted Features Successfully', data);
        this.selection = new SelectionModel<Flow>(true, []);
        this.getAllFeatures();
      }
    });
  }

  closeSuccess() {
    this.success = [];
  }

  closeFailure() {
    this.failure = [];
  }

  previewFeature() {
    this.adminService.closeFeatureExpansionPanel.emit(true);
    this.storageService.setReview(true);
    this.storageService.setPreviewFromPublish(true);
    environment.applicationName = this.adminService.selectedApplication;
    const dialogRef = this.dialog.open(PreviewFeatureFlowDialogComponent, {
      data: this.selection.selected.map(x => x.controls[0]), position: {
        top: '10px',
        right: '10px',
        left: '7px'
      },
      height: '98%',
      width: '100vw',
      maxWidth: '99vw',
      panelClass: 'full-screen-modal',
      id: environment.applicationName + '-preview-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.storageService.setPreviewFromPublish(true);
      this.storageService.setReview(false);
      if (result) {
      }
    });
  }

  navigateToSupportTopic(control) {
    console.log('control', control);
    const selectedIssueId: string = control['issueId'];
    this.adminService.isFeatureInViewMode = true;
    this.adminService.selectedFeatureTargetId = selectedIssueId;
    this.router.navigate(['admin/feature']);
  }

}

